/*
    GOAL GETTER FORM LOGIC
 */
/*
 goalGetter FORM LOGIC
 */

goalGetter = {
    init: function () {
        goalGetter.cE();
    },

    cE: function cacheElements() {

        goalGetter.form = $( 'form#goal-getter-form' );
        goalGetter.submitButton = $( '#submit-goal-getter-form' );

        goalGetter.input = $( 'input' );
        goalGetter.fnInput = $( 'input[name="firstName"]' );
        goalGetter.emailInput = $( 'input[name="email"]' );
        goalGetter.onLivaloInput = $( 'input[name="onLivalo"]' );
        goalGetter.onLivaloWrapper = $('.on-livalo-wrapper');

        goalGetter.utmQuery = window.location.search.substring(1);
        goalGetter.utmVariables = goalGetter.utmQuery.split('&');
        goalGetter.utmParameters = [
            'utm_source',
            'utm_medium',
            'utm_campaign',
            'utm_content',
            'utm_term'
        ]

        goalGetter.formValid = true;
        goalGetter.emailValid = true;

        goalGetter.el();
    } ,
    el: function eventListeners() {
        // Set UTM parameters to hidden fields on page load
        goalGetter.getUTMValue();
        goalGetter.input.on('focusout', function() {
            if ($(this).attr('name') === 'moc'){
                if (goalGetter.onLivaloInput.is(':checked') && goalGetter.onLivaloWrapper.hasClass('error-required')){
                    goalGetter.hideError(goalGetter.onLivaloInput, 'required', true);
                }
            }
            if ($(this).attr('id') === 'email'){
                // if the error class is already on this parent AND the email is now valid, remove error classes
                const valid = goalGetter.validateEmail(this.value, false);

                if (!this.value && ($(this).parent().hasClass('error-valid') || $(this).parent().hasClass('error-required'))){
                    goalGetter.hideError(this, 'valid');
                    goalGetter.hideError(this, 'required');
                } else if (($(this).parent().hasClass('error-valid') || $(this).parent().hasClass('error-required')) && valid) {
                    goalGetter.hideError(this, 'valid');
                    goalGetter.hideError(this, 'required');
                }  else if (!valid) {
                    if ($(this).parent().hasClass('error-required')){
                        goalGetter.hideError(this, 'required');
                    }
                    goalGetter.showError(this, 'valid');
                }
            }
            if ($(this).attr('id') === 'firstName' && this.value && $(this).parent().hasClass('error-required')){
                goalGetter.hideError(this, 'required');
            }
        });
        goalGetter.onLivaloInput.change(function(){
            if (goalGetter.onLivaloInput.is(':checked') && goalGetter.onLivaloWrapper.hasClass('error-required')){
                goalGetter.hideError(goalGetter.onLivaloInput, 'required', true);
            }
        });
        goalGetter.submitButton.on( 'click' ,function (e) {
            e.preventDefault();

            // Check first name and last name for values
            const firstNameValid = goalGetter.validateNames(goalGetter.fnInput);
            const emailIsValid = goalGetter.validateEmail(goalGetter.emailInput, true);
            const onLivaloIsValid = goalGetter.validateOnLivalo();

            if(firstNameValid && emailIsValid && onLivaloIsValid ) {
                const formData = $('form').serialize();

                // SUBMIT FORM
                $.ajax({
                    method: 'POST',
                    url: '/api/goalgetter',
                    data: formData,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                }).done(function ($data) {
                    if (!JSON.parse($data).success){
                        console.log('error');
                    } else {
                        window.dataLayer.push({
                            'event': 'e_form_submit',
                            'eventInfo': {
                                'category': 'Form',
                                'action': 'Submit',
                                'label': 'Receive Support'
                            }
                        });
                        $('.goal-getter-form-wrapper > .form-wrapper').addClass('success');
                        // scroll to top of success section
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $(".goal-getter-form-wrapper").offset().top
                        }, 1000);
                    }

                }).fail(function ($data) {
                    console.warn($data);
                    console.log('error');
                });
            } else {
                // Scroll to first error on page
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".error:first").offset().top
                }, 1000);
            }
        } );

    } ,
    // UTM HELPER FUNCTIONS
    getUTMValue: function(){
        $.each(goalGetter.utmVariables, function(){
            let utm = this.split('=');
            let utmName = utm[0];
            let utmValue = utm[1];
            if(goalGetter.utmParameters.indexOf(utmName) !== -1){
                let input = document.getElementById(utmName);
                input.value = utmValue;
            }
        });
    },
    // SHOW ERRORS
    showError: function (element ,error, onLivalo) {
        if (onLivalo){
            goalGetter.onLivaloWrapper.addClass( 'error-required error' );
        } else {
            switch (error) {
                case 'valid':
                    $( element ).parent().addClass( 'error-valid' );
                    $( element ).parent().addClass( 'error' );
                    break;
                case 'required':
                    $( element ).parent().addClass( 'error-required' );
                    $( element ).parent().addClass( 'error' );
                    break;
            }
        }

    } ,
    // HIDE ERRORS
    hideError: function (element ,error, onLivalo) {
        if (onLivalo){
            goalGetter.onLivaloWrapper.removeClass( 'error-required error' );
        } else {
            switch (error) {
                case 'valid':
                    $( element ).parent().removeClass( 'error-valid' );
                    $( element ).parent().removeClass( 'error' );
                    break;
                case 'required':
                    $( element ).parent().removeClass( 'error-required' );
                    $( element ).parent().removeClass( 'error' );
                    break;
            }
        }
    },
    // CHECK VALIDITY OF EMAIL ON FOCUS OUT OF FIELD
    validateEmail: function(email, submit) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[ 0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (submit){
            const matches = email.val().match(re);
            if (email.val().length > 0 && matches){
                if ($(email).parent().hasClass('error-valid') || $(email).parent().hasClass('error-required')){
                    goalGetter.hideError(email[0], 'valid');
                    goalGetter.hideError(email[0], 'required');
                }
                goalGetter.emailValid = true;
                return true;
            } else if (submit && email.val().length === 0){
                goalGetter.emailValid = false;
                goalGetter.showError(email[0], 'required');
                return false;
            } else if (!matches){
                goalGetter.emailValid = false;
                if ($(email).parents().hasClass('error-required')){
                    goalGetter.hideError(email, 'required');
                }
                goalGetter.showError(email, 'valid');
                return false;
            }
        } else {
            if (email.length > 0 && email.match(re)){
                goalGetter.emailValid = true;
                return true;
            }  else if (email.length === 0){
                goalGetter.emailValid = false;
                return false;
            } else {
                goalGetter.emailValid = false;
                return false;
            }
        }
    },

    validateNames: function(name){
        if (!name.val()){
            goalGetter.showError(name, 'required');
            return false;
        } else {
            if (name.parent().hasClass('error-required')){
                goalGetter.hideError(name, 'required');
                return true;
            } else {
                return true;
            }
        }
    },
    validateOnLivalo: function(){
        if (goalGetter.onLivaloInput.is(':checked')){
            return true;
        } else {
            goalGetter.showError(goalGetter.onLivaloInput, 'required', true);
        }
    }
}
